import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Divider, Empty, Icon, Spin,
} from 'antd';
import { bindActionCreators } from 'redux';
import Box from '../../shared/components/basic/Box';
import LentesList from '../components/list/LentesList';
import {
  getColoresLenteRequest,
  getDiametrosPosiblesRequest,
  getLentesListRequest, nextPageAction,
  obtenerDatosLentesRequest,
  seleccionarColorIntensidad,
  setAlturaFocal,
  setSelecccionDiametroLente,
  setSelecccionLente,
  setSelecccionTratamientoLente,
} from '../../../state/actions/creators/pel.actioncreator';
import Flex from '../../shared/components/basic/Flex';

function PELSeleccionLentesList(props) {
  const {
    lentes,
    errorSeleccion,
    permisos,
    pasillos,
    indices,
    setSelecccionLente,
    setAlturaFocal,
    setSelecccionTratamientoLente,
    setSelecccionDiametroLente,
    getColoresLenteRequest,
    getDiametrosPosiblesRequest,
    seleccionarColorIntensidad,
    barraBusquedaValue,
    gamaColor,
    loadingListado,
    loadingColores,
    loadingFabricantes,
    loadingPasillos,
    loadingIndices,
    loadingDiametrosLente,
    loadingTratamientosLente,
    loadingColoresLente,
    graduacion,
    miColor,
    gamasColoresFormulario,
    obtenerDatosLentesRequest,
    tratamientoSeleccionado,
    hideLastBorder,
    modo,
    modoNoPel,
    nextPageAction,
    getLentesListRequest,
    pagina,
  } = props;
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  const lentesKeys = Object.keys(lentes);
  /*
  const lentesFiltradas = (barraBusquedaValue) ? {} : lentes;
  if (barraBusquedaValue) {
    for (let i = 0; i < lentesKeys.length; i++) {
      const l = lentes[lentesKeys[i]];
      if (l.nombreCompleto.toUpperCase().indexOf(barraBusquedaValue.toUpperCase()) !== -1) lentesFiltradas[lentesKeys[i]] = l;
    }
  }
   */
  const isEmpty = lentesKeys.length === 0;
  const isLoading = loadingListado && loadingColores && loadingFabricantes && loadingIndices && loadingPasillos
    && (loadingListado.running || loadingColores.running || loadingFabricantes.running
      || loadingIndices.running || loadingPasillos.running);

  const onHandleNextPage = (pagina) => {
    getLentesListRequest({ textoBusqueda: barraBusquedaValue, pagina });
    nextPageAction();
  };

  return (
    <Box id="infinite-scroll-pel-div" height="100%" overflow="auto" justifyContent="center">
      {!isEmpty && (
        <LentesList
          modoNoPel={modoNoPel}
          errorSeleccion={errorSeleccion}
          trabajaConColores={permisos ? permisos.configuracion.micatalogo_colores_personalizados !== 'N' : false}
          alturaFocalObligatoria={permisos ? permisos.configuracion.obligatorio_altura_focal == 1 : false}
          loadingColoresLente={loadingColoresLente}
          loadingDiametrosLente={loadingDiametrosLente}
          loadingTratamientosLente={loadingTratamientosLente}
          getColoresLenteRequest={getColoresLenteRequest}
          getDiametrosPosiblesRequest={getDiametrosPosiblesRequest}
          tratamientoSeleccionado={tratamientoSeleccionado}
          lentes={lentes}
          pasillo={pasillos.find(e => e.isSelected)}
          indices={indices}
          graduaciones={graduacion}
          miColor={miColor}
          gamasColoresOpciones={gamasColoresFormulario && gamasColoresFormulario.opciones ? gamasColoresFormulario.opciones : null}
          gamaColor={gamaColor}
          obtenerDatosLentesRequest={obtenerDatosLentesRequest}
          setSelecccionLente={setSelecccionLente}
          setSelecccionTratamientoLente={setSelecccionTratamientoLente}
          seleccionarColorIntensidad={seleccionarColorIntensidad}
          setSelecccionDiametroLente={setSelecccionDiametroLente}
          setAlturaFocal={setAlturaFocal}
          modo={modo}
          isLoading={isLoading}
          onNextPage={() => onHandleNextPage(pagina + 1)}
        />
      )}
      {!hideLastBorder && <Box px={16}><Divider style={{ marginTop: 1, marginBottom: 0 }} /></Box>}
      {!isLoading && isEmpty && <Flex alignItems="center" justifyContent="space-around" height="95%"><Empty description="No se encontraron datos" /></Flex>}
    </Box>
  );
}

const mapStateToProps = ({ pel, sagas, auth }) => ({
  lentes: pel.filtrador.lentes,
  errorSeleccion: pel.filtrador.errorSeleccion,
  permisos: auth.permisos,
  catalogo: pel.filtrador.selecciones.catalogo,
  usaMiCatalogo: pel.usaMiCatalogo,
  tratamientoSeleccionado: pel.filtrador.selecciones.tratamientos,
  indices: pel.filtrador.selecciones.indices,
  pasillos: pel.filtrador.selecciones.pasillos,
  graduacion: pel.filtrador.selecciones.graduacion,
  gamaColor: pel.filtrador.selecciones.colores,
  miColor: pel.filtrador.selecciones.miColor,
  gamasColoresFormulario: pel.filtrador.formulario.colores,
  barraBusquedaValue: pel.filtrador.barraBusqueda.value,
  pagina: pel.filtrador.pagina,
  loadingListado: sagas.LENTES_PEL_GET_LENTES_LIST,
  loadingColores: sagas.LENTES_PEL_GET_COLORES,
  loadingFabricantes: sagas.LENTES_PEL_GET_FABRICANTES,
  loadingPasillos: sagas.LENTES_PEL_GET_PASILLOS,
  loadingIndices: sagas.LENTES_PEL_GET_INDICES,
  loadingDiametrosLente: sagas.LENTES_PEL_GET_DIAMETROS_POSIBLES,
  loadingTratamientosLente: sagas.LENTES_PEL_GET_TRATAMIENTOS_POSIBLES,
  loadingColoresLente: sagas.LENTES_PEL_GET_COLORES_LENTE,
  modoNoPel: pel.modoNoPel,

});
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setSelecccionLente,
    setSelecccionTratamientoLente,
    seleccionarColorIntensidad,
    getLentesListRequest,
    nextPageAction,
    getColoresLenteRequest,
    getDiametrosPosiblesRequest,
    setSelecccionDiametroLente,
    obtenerDatosLentesRequest,
    setAlturaFocal,
  }, dispatch);
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PELSeleccionLentesList);

PELSeleccionLentesList.propTypes = {
  lentes: PropTypes.shape({

  }),
  permisos: PropTypes.shape({}).isRequired,
  catalogo: PropTypes.shape({ id: PropTypes.number }),
  indices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  modo: PropTypes.string.isRequired,
  pasillos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    isSelected: PropTypes.bool,
  })),
  graduacion: PropTypes.shape({

  }),
  miColor: PropTypes.shape({

  }),
  gamasColoresFormulario: PropTypes.shape({

  }),
  tratamientoSeleccionado: PropTypes.shape({

  }),
  barraBusquedaValue: PropTypes.string,
  gamaColor: PropTypes.shape({
    id: PropTypes.number,
    categoria_id: PropTypes.number,
    clasificacion_foco_id: PropTypes.number,
    gama_color: PropTypes.string,
    nombre: PropTypes.string,
    valor: PropTypes.number,
    empresa_id: PropTypes.number,
    tipo_id: PropTypes.number,
    activa: PropTypes.bool,
    oculta: PropTypes.bool,
    foto: PropTypes.string,
  }).isRequired,
  setSelecccionLente: PropTypes.func,
  setAlturaFocal: PropTypes.func,
  setSelecccionTratamientoLente: PropTypes.func,
  setSelecccionDiametroLente: PropTypes.func,
  obtenerDatosLentesRequest: PropTypes.func,
  seleccionarColorIntensidad: PropTypes.func,
  getColoresLenteRequest: PropTypes.func,
  getDiametrosPosiblesRequest: PropTypes.func,
  usaMiCatalogo: PropTypes.bool,
  hideLastBorder: PropTypes.bool,
  loadingListado: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingColores: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingColoresLente: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingDiametrosLente: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingTratamientosLente: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingFabricantes: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingPasillos: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  loadingIndices: PropTypes.shape({ running: PropTypes.bool, success: PropTypes.bool }),
  pagina: PropTypes.number,

};
PELSeleccionLentesList.defaultProps = {
  lentes: {},
  graduacion: {},
  pasillos: [],
  loadingListado: { running: false, success: false },
  loadingColores: { running: false, success: false },
  loadingColoresLente: { running: false, success: false },
  loadingDiametrosLente: { running: false, success: false },
  loadingTratamientosLente: { running: false, success: false },
  loadingFabricantes: { running: false, success: false },
  loadingPasillos: { running: false, success: false },
  loadingIndices: { running: false, success: false },
  barraBusquedaValue: null,
  gamasColoresFormulario: null,
  miColor: null,
  pagina: 0,
  catalogo: {},
  tratamientoSeleccionado: null,
  usaMiCatalogo: true,
  hideLastBorder: false,
  setSelecccionLente: () => {},
  setAlturaFocal: () => {},
  setSelecccionTratamientoLente: () => {},
  obtenerDatosLentesRequest: () => {},
  setSelecccionDiametroLente: () => {},
  seleccionarColorIntensidad: () => {},
  getColoresLenteRequest: () => {},
};
